export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6166.9e52986e.jpg";